import styled from 'styled-components';

import { Flex, token } from '@zillow/constellation';

export const StyledFlex = styled(Flex)`
  background-color: ${token('colors.blue100')};
  width: 100%;
`;
